<template>
  <div class="navbar">
    <div class="navbar-container">
      <el-menu :default-active="current_path"
               mode="horizontal"
               background-color="rgba(32, 32, 32, 1)"
               text-color="rgba(255, 255, 255, 1)"
               active-text-color="rgba(0, 158, 255, 1)"
               router>
        <!--主要模块-->
        <el-menu-item class="elitem"
                      index="/control/"
                      v-if="has_module_permission('control')">
          <span class="i common-navbar-control"></span>
          <span>设备控制</span>
        </el-menu-item>
        <el-menu-item class="elitem"
                      index="/task/"
                      v-if="has_module_permission('cron')">
          <span class="i common-navbar-task"></span>
          <span>任务策略</span>
        </el-menu-item>
        <el-menu-item class="elitem"
                      index="/log/"
                      v-if="has_module_permission('log')">
          <span class="i common-navbar-log"></span>
          <span>日志记录</span>
        </el-menu-item>
        <el-menu-item class="elitem"
                      index="/data/"
                      v-if="has_module_permission('data')">
          <span class="i common-navbar-data"></span>
          <span>数据统计</span>
        </el-menu-item>
        <el-menu-item class="elitem"
                      index="/manage/"
                      v-if="has_module_permission('system')">
          <span class="i common-navbar-system"></span>
          <span>系统管理</span>
        </el-menu-item>

        <!--右边内容-->
        <el-menu-item class="right-menu-item"
                      index>
          <el-tooltip effect="dark"
                      placement="bottom">
            <div slot="content"
                 class="slotcontent">
              <p>系统信息: {{softname}}</p>
              <p>系统版本: V{{version}}</p>
            </div>
            <el-button type="text"
                       icon="el-icon-info"></el-button>
          </el-tooltip>
        </el-menu-item>
        <el-menu-item index
                      class="right-menu-item">
          <el-button type="text"
                     class="quit"
                     @click="logout"
                     style="color: white;">退出
          </el-button>
        </el-menu-item>

        <el-menu-item index
                      class="right-menu-item">
          <el-button type="text"
                     class="username"
                     @click="user_dialog_visible = true"
                     icon="i common-navbar-user"
                     style="color: white">
            <span style="margin-left:6px">{{username}}</span>
          </el-button>
        </el-menu-item>
        <el-menu-item index
                      class="right-menu-item">
          <el-button type="text"
                     class="home_page"
                     @click="go_fullScreen"
                     style="color: white;">首页
          </el-button>
        </el-menu-item>
      </el-menu>
    </div>
    <!-- 用户信息模态框 -->
    <el-dialog title="密码修改"
               :visible.sync="user_dialog_visible"
               width="270px"
               :close-on-click-modal='false'
               center>
      <el-form :model="user_form"
               v-if="user_dialog_visible"
               label-width="80px"
               label-position="left"
               :rules="user_form_rules"
               size="medium"
               ref="user_form">
        <el-form-item label="当前密码"
                      prop="old_password">
          <el-input v-model="user_form.old_password"
                    type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码"
                      prop="new_password1">
          <el-input v-model="user_form.new_password1"
                    type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码"
                      prop="new_password2">
          <el-input v-model="user_form.new_password2"
                    type="password"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancel ">取消</el-button>
        <el-button type="primary"
                   @click="change_password('user_form')">修改</el-button>
      </span>
    </el-dialog>

    <div class="main-content">
      <!--<transition name="router-transform" mode="out-in">-->
      <router-view/>
      <!--</transition>-->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      var valid_password = {max: 64, min: 6, message: '长度6-64'}
      return {
        // win_exe
        download_exe_url:
        api.downloadLog_url +
        'TecxenScIOT.exe' +
        '?token=' +
        localStorage.getItem('token'),

        username: localStorage.getItem('username') || 'admin',
        version: localStorage.getItem('version'),
        max_node_num: localStorage.getItem('max_node_num'),
        softname: localStorage.getItem('softname'),

        //用户信息
        user_dialog_visible: false,
        user_form: {
          old_password: '',
          new_password1: '',
          new_password2: ''
        },
        user_form_rules: {
          old_password: [{required: true, message: '必填项!'}],
          new_password1: [{required: true, message: '必填项!'}, valid_password],
          new_password2: [{required: true, message: '必填项!'}, valid_password]
        },
        // 管理员权限
        is_admin: localStorage.getItem('can_all') === 'true',

        // 模块权限
        module_permissions: JSON.parse(localStorage.getItem('module_permissions'))
      }
    },

    computed: {
      current_path() {
        return this.$route.matched[0].path + '/'
      }
    },
    watch: {
      // 密码置空
      user_dialog_visible(val) {
        if (!val) {
          this.user_form.old_password = ''
          this.user_form.new_password1 = ''
          this.user_form.new_password2 = ''
        }
      }
    },
    methods: {
      // 密码置空
      cancel() {
        this.user_dialog_visible = false
        this.user_form.old_password = ''
        this.user_form.new_password1 = ''
        this.user_form.new_password2 = ''
      },
      has_module_permission(module_name) {
        // 判断是否有此模块的权限

        // 如果是管理员
        if (this.is_admin) {
          return true
        }

        // 判断是否有此模块的权限
        let mp = this.module_permissions
        if (mp) {
          let result = false
          for (let key in mp[module_name]) {
            // 只有该类里面有一个权限就把这个目录显示出来
            if (mp[module_name][key].read) {
              result = true
            }
          }
          return result
        } else {
          return false
        }
      },
      change_password(form_name) {
        if (this.user_form.new_password1 !== this.user_form.new_password2) {
          this.msg.msg('两次密码不一致', 'w')
          return
        }
        this.$refs[form_name].validate(valid => {
          if (valid) {
            this.$http.post(api.changePassword_url, this.user_form).then(resp => {
              if (resp.data.success) {
                this.msg.msg(resp.data.data)
                this.logout()
              } else {
                this.msg.msg(resp.data.data, 'e')
              }
            })
          }
        })
      },
      logout() {
        localStorage.clear()
        delete this.$http.defaults.headers.common.Authorization
        this.$router.push('/login')
      },
      // 点击logo跳转到大屏
      go_fullScreen() {
        this.$router.replace('/')
      }
    }
  }
</script>
<style>
  .navbar .el-icon-info {
    color: #409eff !important;
    background-color: rgba(32, 32, 32, 1);
  }

  .navbar .el-tooltip__popper.is-dark {
    height: 200px !important;
  }
</style>
<style scoped>
  .navbar {
    margin-left: 200px;
    background-color: rgba(32, 32, 32, 1);
    height: 85px;
  }

  .navbar /deep/ .el-menu--horizontal > .el-menu-item {
    height: 76px;
    line-height: 76px;
  }

  .navbar /deep/ .el-menu--horizontal > .el-menu-item.is-active {
    background: rgba(113, 203, 255, 0.05) !important;
    border-bottom: 2px solid #409eff !important;
  }

  .navbar /deep/ .el-menu--horizontal > .el-menu-item.is-active span {
    color: #409eff !important;
  }

  .navbar-container {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 200px;
    right: 5px;
    box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 0.7);
    font-weight: 500;
  }

  .main-content {
    margin-top: 43px;
  }

  .right-menu-item {
    float: right !important;
  }

  .downuodate {
    margin-right: 30px !important;
  }

  .quit, .home_page {
    font-size: 14px;
  }

  .elitem {
    width: 120px;
  }

  .elitem span {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #D7D7D7;
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue